import comp from "./SchedulePostModal";
export default comp;
